import { AgreeOptions, AgreeOptionsCapitalized } from './AgreeOptions';

export const booleanOptions = [
  { value: AgreeOptionsCapitalized.YES, label: AgreeOptions.YES },
  { value: AgreeOptionsCapitalized.NO, label: AgreeOptions.NO },
];
